import {getFormApplicability} from './getFormApplicability'

export const forms = {
  getFormApplicability,
}
